import styled from "styled-components";
import GenerateProseGoButton from "src/components/StoryBible/GenerateProseGoButton";
import { AppEventPublisher } from "src/AppEventPublisher";
import { TourSignal } from "../../../StickyTour/TourTypes";
import { useStickyTourStore } from "../../../../stores/stickyTourStore";
import { useStoryBibleStore } from "../../../../stores/storyBibleStore";
import { hasUsableDraftEstimate } from "./draftPreflightContract";

const CancelLink = styled.a`
  color: #999;
  margin-right: 8px;
  cursor: pointer;
`;

function CancelPreflightRunProseButtonGroup({ requesting, outOfQuota, setPreflightResponse, draftStateMachine, generateProse, setLastInvocation, editor, editorRef, scene, setScenes, sceneId }) {
  const sendFlowSignal = useStickyTourStore((state) => state.sendFlowSignal);
  const preflightResponse = useStoryBibleStore((state) => state.preflightResponse);
  const isPreflightError = preflightResponse?.ResponseType === "Error";
  const isEstimateMissing = !hasUsableDraftEstimate(preflightResponse?.estimates);

  return (
    <>
      {!requesting && (
        <CancelLink
          href="#"
          onClick={(e) => {
            e.preventDefault();
            AppEventPublisher.storyBible.draft.cancelPreflight();
            setPreflightResponse(null);
            draftStateMachine.events.cancel();
          }}
        >
          Cancel
        </CancelLink>
      )}

      <GenerateProseGoButton
        generateProse={() => {
          if (generateProse()) {
            sendFlowSignal(TourSignal.DRAFT_PROSE_GENERATE_GO_CLICKED);
            setLastInvocation(null);
          }
        }}
        editor={editor}
        editorRef={editorRef}
        scene={scene}
        setScenes={setScenes}
        sceneId={sceneId}
        selectOnly={false}
        generateDisabled={isPreflightError || isEstimateMissing}
        outOfQuotaOverride={outOfQuota}
      />
    </>
  );
}

export default CancelPreflightRunProseButtonGroup;
